module.exports = __webpack_public_path__ + "static/media/ceiling_blaco_redondo.7f440bfc.jpg";